import React, { useEffect, useContext } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Link } from 'react-router-dom';
import { LanguageContext } from '../Context/LanguageContext';

const heroData = {
  en: {
    title: "Welcome to Devora",
    description:"Devora specializes in education, marketing, sales, and software development. We craft smart digital solutions to help individuals and businesses grow through interactive learning, effective marketing strategies, and advanced software systems tailored to market needs.",
    buttons: [
      {
        text: "Learn More",
        link: "/about",
        icon: "fa-arrow-right"
      },
      {
        text: "Get in Touch",
        link: "/contact",
        icon: "fa-phone"
      }
    ],
    imageUrl: "/assets/images/icon.png"
  },
  ar: {
    title: "مرحباً بك في ديفورا",
    description:"ديفورا شركة متخصصة في التعليم، التسويق، المبيعات، وتطوير البرمجيات. نبتكر حلولًا رقمية ذكية تساعد الأفراد والشركات على النمو، من خلال محتوى تعليمي تفاعلي، استراتيجيات تسويق فعّالة، وأنظمة برمجية متطورة تلبي متطلبات السوق.",
    buttons: [
      { text: "اعرف المزيد", link: "/about", icon: "fa-arrow-left" },
      { text: "تواصل معنا", link: "#contact", icon: "fa-phone" }
    ],
    imageUrl: "/assets/images/icon.png"
  }
};

function Hero() {
  const { language } = useContext(LanguageContext);
  const content = heroData[language];

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="hero container-fluid" dir={language === 'ar' ? 'rtl' : 'ltr'}>
      <div className="container py-5 d-flex justify-content-center align-items-center h-100" data-aos="fade-up">
        <div className="row w-100 align-items-center justify-content-center">

          {/* Image */}
          <div
            className="col-md-6 text-center mb-4 mb-md-0 d-flex justify-content-center align-items-center"
            data-aos={language === 'ar' ? 'fade-right' : 'fade-left'}
          >
            <img
              src={content.imageUrl}
              alt="Devora Logo"
              className="img-fluid rotating-image"
              style={{ maxWidth: '420px', maxHeight: '420px' }}
            />
          </div>

          {/* Text */}
          <div
            className="col-md-6 text-white"
            data-aos={language === 'ar' ? 'fade-left' : 'fade-right'}
          >
            <div className="d-flex flex-column gap-4">
              <h1 className="fw-bold fs-1">{content.title}</h1>
              <p className="text-justify">{content.description}</p>
              <div className="d-flex gap-3 flex-wrap">
                {content.buttons.map((btn, index) => (
                  <Link
                    key={index}
                    to={btn.link}
                    className={`btn ${index === 0 ? 'btn-df' : 'btn-df-outline'} d-flex align-items-center gap-2`}
                    onClick={(e) => {
                      e.preventDefault();
                      const targetId = btn.link.substring(1);
                      const targetElement = document.getElementById(targetId);
                      if (targetElement) {
                        targetElement.scrollIntoView({ behavior: 'smooth' });
                      }
                    }}
                  >
                    {btn.text}
                    <i className={`fa-solid ${btn.icon} ${language === 'ar' ? 'ms-2' : 'me-2'}`}></i>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hero;
